module.exports = __webpack_public_path__ + "static/img/shouye.132462a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/shouye.jpg
// module id = QGHv
// module chunks = 1